import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesRecommendedAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesRecommendedAction(
  casuistic,
  dailyWetReducerAmounts,
  mealsPerDay,
  speciesId,
  breedId,
  birth,
  isMale,
  sterilisedId,
  pregnancyId,
  lactationId,
  litterSize,
  currentBodyWeight,
  goalWeight,
  bodyConditionScore,
  isWeightAdjustment,
  durationId,
  intensityFieldId,
  environmentTemperature,
  diagnoses,
  isCriticalCare,
  products,
  isAnorexia
) {
  
  const data = {
    casuistic: casuistic,
    snackKcal: dailyWetReducerAmounts.snackKcal,
    relatedKcal: dailyWetReducerAmounts.relatedKcal,
    wetKcal: dailyWetReducerAmounts.wetKcal,
    dryKcal: dailyWetReducerAmounts.dryKcal,
    wetGrams: dailyWetReducerAmounts.wetGrams,
    dryGrams: dailyWetReducerAmounts.dryGrams,
    mealsPerDay: mealsPerDay,
    speciesId: speciesId,
    breedId: breedId,
    birth: birth,
    isMale: isMale,
    sterilisedId: sterilisedId,
    pregnancyId: pregnancyId,
    lactationId: lactationId,
    litterSize: litterSize,
    currentBodyWeight: currentBodyWeight,
    goalWeight: goalWeight,
    bodyConditionScore: bodyConditionScore,
    isWeightAdjustment: isWeightAdjustment,
    durationId: durationId,
    intensityFieldId: intensityFieldId,
    environmentTemperature: environmentTemperature,
    diagnoses: diagnoses,
    isCriticalCare: isCriticalCare,
    products: products,
    isAnorexia: isAnorexia,
  }

  const queryString = Object.keys(data).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&');
  return fetchApi('/v1/fc_api/feeding_guidelines_recommended_resource?' + queryString, fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesRecommendedAction;
